"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _props = require("../styles/props");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Module dependencies.
 */

/**
 * Export `Box` component.
 */
var Box = _styledComponents.default.div.withConfig({
  displayName: "box__Box",
  componentId: "sc-1it47br-0"
})(["", ""], _props.setStyledProps);

exports.Box = Box;